import isEmpty from 'lodash/isEmpty';

export default function hasRecentSearches(state) {
  return !isEmpty(state.search.recentSearches);
}
